import request from '@/utils/request'

const getCourseContextById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/${id}`,
    method: 'get'
  })
}

const getCourseContextPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/page-list`,
    method: 'get',
    params: query
  })
}

function createCourseContext(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context`,
    method: 'post',
    data
  })
}

const updateCourseContext = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/${id}`,
    method: 'put',
    data
  })
}

const saveCourseContext = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/${id}/save`,
    method: 'put',
    data
  })
}

const getCourseContextByCatalogIdAndType = (catalogId, type) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/by-catalog-id-and-type/${catalogId}`,
    method: 'get',
    params: { type }
  })
}

const deleteCourseContext = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-context/${id}`,
    method: 'delete'
  })
}

export default {
  createCourseContext,
  updateCourseContext,
  saveCourseContext,
  getCourseContextById,
  getCourseContextPageList,
  getCourseContextByCatalogIdAndType,
  deleteCourseContext
}
